import { Select, SelectOption } from '@ardoq/select';
import { Operator } from '@ardoq/api-types';
import { RemoveFilterButtonInTopRightCorner, SelectContainer } from './atoms';
import { ValuePresenceColumnFilterProps } from '../types';
import { Maybe } from '@ardoq/common-helpers';
import { VALUE_PRESENCE_FILTER_OPERATORS } from './filterUtils';
import { pick } from 'lodash';
import { DEFAULT_OPERATOR_TO_LABEL } from '@ardoq/query-builder';

const VALUE_PRESENCE_OPERATOR_SELECT_OPTIONS = Object.entries(
  pick(DEFAULT_OPERATOR_TO_LABEL, VALUE_PRESENCE_FILTER_OPERATORS)
).map(([operator, label]) => ({
  label,
  value: operator,
})) as SelectOption<Operator>[];

export const ValuePresenceColumnFilter = ({
  column,
  selected,
  menuTarget,
  isReadOnly,
  removeFilter,
  changeFilterExpression,
}: ValuePresenceColumnFilterProps & {
  menuTarget: Maybe<HTMLElement>;
}) => {
  const selectedOperator = selected[0]?.operator;
  return (
    <SelectContainer>
      {!isReadOnly && (
        <RemoveFilterButtonInTopRightCorner
          onClick={() => removeFilter(column.key)}
        />
      )}
      <Select
        label={column.label}
        options={VALUE_PRESENCE_OPERATOR_SELECT_OPTIONS}
        value={selectedOperator}
        onChange={operatorOption => {
          if (operatorOption) {
            changeFilterExpression(column, [
              { value: null, operator: operatorOption.value },
            ]);
          }
        }}
        menuPortalTarget={menuTarget}
        isReadOnly={isReadOnly}
      />
    </SelectContainer>
  );
};
